import { authAPI } from './api';

class TokenManager {
  constructor() {
    this.ACCESS_TOKEN_KEY = 'booking_app_access_token';
    this.REFRESH_TOKEN_KEY = 'booking_app_refresh_token';
    this.TOKEN_EXPIRY_KEY = 'booking_app_token_expiry';
    this.refreshPromise = null;
  }

  setTokens(accessToken, refreshToken, expiresIn) {
    localStorage.setItem(this.ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken);

    const expiryTime = Date.now() + expiresIn * 1000 - 5 * 60 * 1000;
    localStorage.setItem(this.TOKEN_EXPIRY_KEY, expiryTime.toString());
  }

  getAccessToken() {
    return localStorage.getItem(this.ACCESS_TOKEN_KEY);
  }

  getRefreshToken() {
    return localStorage.getItem(this.REFRESH_TOKEN_KEY);
  }

  isTokenExpired() {
    const expiryTime = localStorage.getItem(this.TOKEN_EXPIRY_KEY);
    if (!expiryTime) return true;

    return Date.now() >= parseInt(expiryTime);
  }

  getTimeUntilExpiry() {
    const expiryTime = localStorage.getItem(this.TOKEN_EXPIRY_KEY);
    if (!expiryTime) return 0;

    const timeLeft = parseInt(expiryTime) - Date.now();
    return Math.max(0, Math.floor(timeLeft / (1000 * 60)));
  }

  async refreshTokens() {
    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    const refreshToken = this.getRefreshToken();
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    this.refreshPromise = authAPI
      .refreshToken(refreshToken)
      .then(response => {
        const { accessToken, refreshToken: newRefreshToken, expiresIn } = response.data;
        this.setTokens(accessToken, newRefreshToken, expiresIn);
        this.refreshPromise = null;
        return accessToken;
      })
      .catch(error => {
        this.refreshPromise = null;
        this.clearTokens();
        throw error;
      });

    return this.refreshPromise;
  }

  clearTokens() {
    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    localStorage.removeItem(this.TOKEN_EXPIRY_KEY);
  }

  async ensureValidToken() {
    if (this.isTokenExpired()) {
      try {
        await this.refreshTokens();
      } catch (error) {
        console.error('Token refresh failed:', error);
        throw error;
      }
    }

    return this.getAccessToken();
  }

  startAutoRefresh() {
    setInterval(() => {
      const timeLeft = this.getTimeUntilExpiry();

      if (timeLeft <= 5 && timeLeft > 0) {
        this.refreshTokens().catch(error => {
          console.error('Auto-refresh failed:', error);
        });
      }
    }, 60000);
  }

  hasValidTokens() {
    return !!(this.getAccessToken() && this.getRefreshToken() && !this.isTokenExpired());
  }
}

const tokenManager = new TokenManager();
export default tokenManager;
